import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { ServiceModel } from "../../models/service.model";

interface _ServiceGetParams {
    search?: string;
}

@injectable()
export class ServiceRepo extends TableRepo<ServiceModel> {
    constructor() {
        super("/api/Service");
    }

    async getData(index: number, params: _ServiceGetParams, pageSize = 10): Promise<ApiPage<ServiceModel>|null> {
        return await super.getData(index, params, pageSize);
    }
}